import { boot } from 'quasar/wrappers';
import messages from '../i18n';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

declare module 'vue/types/vue' {
  interface Vue {
    i18n: VueI18n;
  }
}

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages
});

Vue['i18n'] = i18n;

export default boot(({ app }) => {
  // Set i18n instance on app
  app.i18n = i18n;
});
